
import {addCountry,deleteCountry,updateCountry,getAllCountries,getCountry,searchCountry } from '@/services/endpoints/countries'

export default {
    async addCountry({ commit }, payload) {
        try {
            let res = await addCountry(payload)
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },

    async deleteCountry({ commit }, payload) {
        try {
            let res = await deleteCountry(payload.countriesId)
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async getAllCountries({ commit },payload) {
        try {
            let res = await getAllCountries(payload);
            if(res) {
                commit('SET_COUNTRIES', res.data.data)
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async updateCountry({commit},payload) {
        try {
            let res = await updateCountry(payload.id, payload.payload);
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async searchCountry({ commit }, payload) {
        try {
            let res = await searchCountry(payload);
            if(res) {
                res.data.data.forEach((s,index) => {
                    s.id = index
                });

                commit('SET_COUNTRIES', res.data.data)
                commit('SET_ISSUED_COUNTRIES', res.data.data)
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getCountriesToEdit({ commit }, countryId) {
        try {
            let res = await getCountry(countryId);
            if(res) {
                commit('SET_COUNTRY_TO_EDIT', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
}